<template>
  <div style="overflow: auto">
    <v-col cols="12">
      <table
        class="table table-bordered table-striped"
        v-if="listData.length != 0 && !loading"
        style="margin-right: 15px"
      >
        <thead class="thead-light">
          <tr>
            <th rowspan="2" style="vertical-align: middle">Month</th>
            <th colspan="2">Total</th>
            <th rowspan="2" style="vertical-align: middle">Revenue</th>
            <th colspan="2">Profit</th>
            <th colspan="3">Ad Spent</th>
            <th rowspan="2" style="vertical-align: middle">Salary</th>
            <th rowspan="2" style="vertical-align: middle">Net Profit</th>
          </tr>
          <tr>
            <th>Orders</th>
            <th>Sales</th>
            <th>Temp</th>
            <th>Gross</th>
            <th>Facebook</th>
            <th>Google</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr
            v-for="(value, text, index) in listData.report_for_each_month"
            :key="index"
          >
            <td>
              <div>{{ text }}</div>
            </td>
            <td>{{ value.total_order }}</td>
            <td>{{ value.total_sales }}</td>
            <td>{{ parseFloat(value.revenue).toFixed(2) }}</td>
            <td>{{ parseFloat(value.temp_profit).toFixed(2) }}</td>
            <td>{{ parseFloat(value.gross_profit).toFixed(2) }}</td>
            <td>{{ parseFloat(value.facebook_ad_spent).toFixed(2) }}</td>
            <td>{{ parseFloat(value.google_ad_spent).toFixed(2) }}</td>
            <td>{{ parseFloat(value.total_ad_spent).toFixed(2) }}</td>
            <td>{{ value.salary }}</td>
            <td>{{ parseFloat(value.net_profit).toFixed(2) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td>{{ listData.total_order_in_year }}</td>
            <td>{{ listData.total_sales_in_year }}</td>
            <td>{{ parseFloat(listData.total_revenue_in_year).toFixed(2) }}</td>
            <td>
              {{ parseFloat(listData.total_temp_profit_in_year).toFixed(2) }}
            </td>
            <td>
              {{ parseFloat(listData.total_gross_profit_in_year).toFixed(2) }}
            </td>
            <td>
              {{
                parseFloat(listData.total_facebook_ad_spent_in_year).toFixed(2)
              }}
            </td>
            <td>
              {{
                parseFloat(listData.total_google_ad_spent_in_year).toFixed(2)
              }}
            </td>
            <td>
              {{ parseFloat(listData.total_ad_spent_in_year).toFixed(2) }}
            </td>
            <td>{{ listData.total_salary_in_year }}</td>
            <td>
              {{ parseFloat(listData.total_net_profit_in_year).toFixed(2) }}
            </td>
          </tr>
          <template v-if="listData.tier == 0">
            <tr class="tier0">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 1">
            <tr class="tier1">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 2">
            <tr class="tier2">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 3">
            <tr class="tier3">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 4">
            <tr class="tier4">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 5">
            <tr class="tier5">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else-if="listData.tier == 6">
            <tr class="tier6">
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="4">Average Net Profit Last 3 Months:</td>
              <td colspan="2">
                {{
                  parseFloat(listData.average_net_profit_last_3_months).toFixed(
                    2
                  )
                }}
              </td>
              <td colspan="3">Tier:</td>
              <td colspan="2">{{ listData.tier }}</td>
            </tr>
          </template>
        </tfoot>
      </table>
      <div v-else-if="loading">
        <!-- <img v-bind:src="require('../assets/loading/'+link)"> -->
        <img v-bind:src="require('../../assets/loading/loading.gif')" />
      </div>
    </v-col>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
//import moment from 'moment-timezone'
//import axios from "axios"

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "KPIMarketing",
  props: {
    userId: String,
    listData: Object,
  },
  data: () => ({
    loading: false,
    menu2: false,
    report_month: new Date().toISOString().substr(0, 7),
  }),
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.tier0 {
  outline: 4px solid #bdbdbd;
}
.tier1 {
  outline: 4px solid #4caf50;
}
.tier2 {
  outline: 4px solid #82b1ff;
}
.tier3 {
  outline: 4px solid #9c27b0;
}
.tier4 {
  outline: 4px solid #ff8a65;
}
.tier5 {
  outline: 4px solid #f44336;
}
.tier6 {
  outline: 4px solid #ffeb3b;
}
</style>